import React from 'react';
import AccessibilityStore from '../../stores/AccessibilityStore';

class AccessibilityMessage extends React.Component {
  constructor(props) {
    super(props);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.state = {
      currentMessage: '',
    };
  }

  componentWillMount() {
    AccessibilityStore.addChangeListener(this.onStoreChange);
  }

  componentWillUnmount() {
    AccessibilityStore.removeChangeListener(this.onStoreChange);
  }

  onStoreChange() {
    const msg = AccessibilityStore.getCurrentMessage();
    if (msg) {
      setTimeout(() => {
        this.setState({ currentMessage: msg });
      }, 50);
      setTimeout(() => {
        this.setState({ currentMessage: '' });
      }, 500);
    }
  }

  render() {
    const { currentMessage } = this.state;
    return (
      <div
        className="u-visually-hidden off-screen"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {currentMessage ? <span>{currentMessage}</span> : ''}
      </div>
    );
  }
}

export default AccessibilityMessage;
